module.exports = __webpack_public_path__ + "images/portfolio1-2e1fc987ef3b19c27802d2c753539f58.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/portfolio1.png
// module id = 14
// module chunks = 0